import React from 'react';
import { useSelector } from 'react-redux';
import Products from '../Products/Products';

const HomeTopProducts = () => {
  const productList = useSelector((state) => state.products.list);

  return <Products products={productList} amount={4} title="Топ продажів" />;
};

export default HomeTopProducts;
